{
  "list": {
    "title": "Tablets",
    "add": "Pair a tablet",
    "columns": {
      "name": "Device name",
      "branch": "Branch",
      "status": "Status",
      "lastSeen": "Last seen"
    },
    "neverSeen": "Never seen",
    "searchPlaceholder": "Search by device name",
    "rowActions": {
      "trigger": "Actions for {{name}}",
      "disable": "Disable",
      "enable": "Enable"
    }
  },
  "status": {
    "online": "Online",
    "offline": "Offline",
    "disabled": "Disabled"
  },
  "drawer": {
    "pairTitle": "Pair a tablet",
    "editTitle": "Edit tablet",
    "pairDescription": "Enter the pairing code shown on the tablet, then the device name and its branch.",
    "editDescription": "Update the device name and branch.",
    "fields": {
      "code": "Pairing code",
      "name": "Device name",
      "branch": "Branch"
    },
    "codeFormat": "The pairing code has six digits",
    "paired": "Tablet paired successfully",
    "updated": "Tablet updated successfully"
  },
  "statusConfirm": {
    "disableTitle": "Disable this tablet?",
    "enableTitle": "Enable this tablet?",
    "disableDescription": "\"{{name}}\" stops at once, its open operation is cancelled and it must be paired again.",
    "enableDescription": "Enter the pairing code shown on \"{{name}}\" to pair and enable it.",
    "changed": "Tablet status changed successfully"
  }
}
